import React, { useEffect, useState } from "react";
import {
  InputAdornment,
  Tooltip,
  Box,
  Skeleton,
  CssBaseline,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { TextField, ThemeProvider, createTheme } from "@mui/material";
// import { common_axios } from "../../..";
import { common_axios } from "../../../App";
import { ToastContainer, toast } from "react-toastify";
import { Formik, useFormik } from "formik";
import AccountRadioButton from "./AccountRadioButton";
import Swal from "sweetalert2";

const Account = () => {
  const [open, setOpen] = useState(false);
  const [taglineType, setTaglineType] = useState();
  const [disable, setDisable] = useState(true);

  const [details, setDetails] = useState({
    taglineType: "",
  });
  // console.log("tagline----", details.taglineType);
  // ...................................Theme Provider....................................//

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });

  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  // console.log("data---77-", data);
  // console.log("approve-----", data?.credit);
  const callbackFunction = (childData) => {
    setTaglineType(childData);
  };
  const UserId = localStorage.getItem("UserId");
  // console.log("UserId", UserId);
  async function GetAccount(values) {
    try {
      // setOpen(true);
      const result = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API}/admin/v1/user/profile/details?cpId=${UserId}`,

        // `http://192.168.167.66:5001/admin/v1/user/profile/details?cpId=${UserId}`
      );
      // console.log("------resultssss", result);
      if (result.data.statusDescription.statusCode == 200) {
        setData1(result?.data?.userDetail);
        setData(result?.data?.userDetail?.serviceTypeList);

        // setData(result.data.userDetail.roleName);

        // setData(result.data.userDetail);
        // setDetails({
        //   taglineType: result.data.userDetail.roleName,
        // });
        // setData(result.data.userDetail);

        // console.log("updatedata76",updatedata)
        // console.log({itemapproved})
        // toast.success(result.data.statusDescription.description, {
        //   theme: "colored",
        // });
      } else {
        // toast.error(result.data.statusDescription.description);
        Swal.fire({
          icon: "error",
           title: "Oops...",
          text:result.data.statusDescription.description,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // toast.error("Please Check Your Network");
      Swal.fire({
        icon: "error",
         title: "Oops...",
        text:"Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  useEffect(() => {
    GetAccount();
  }, []);

  return (
    <>
     <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <ThemeProvider theme={theme}>
          <div class="table-responsive mt-4 table_21">
            <table class="table table-sm table-bordered table-striped w-75">
              <thead>
                <tr class="table-primary text-center fw-bold">
                  <th colspan="5" class="details">
                    My Account
                  </th>
                </tr>
              </thead>
              <tbody>
                
                <tr>
                  <th>Name</th>
                  {/* <td>01743988402</td> */}
                  <td colSpan="4"><p className="fw-bold m-0">{data1?.name}</p></td>
                </tr>
          

                <tr>
                  <th>Role</th>
                 
                  <td colSpan="4">
                    <p className="fw-bold m-0">{data1?.roleName}</p>
                  </td>
                </tr>

                <tr>
                  <th>Email</th>
                  {/* {data?.map((arg) => {
                    return (
                      <> */}
                      
                        <td>
                          <p className="fw-bold m-0">{data1?.email}</p>

                          {/* <a className="btn btn-primary details m-0 m-1"> */}
                        {/* Tags */}
                        {/* {data1?.email} */}

                        {/* </a> */}
                        </td>
                      {/* </>
                    );
                  })} */}
                </tr>

                {/*   */}

              </tbody>
            </table>
          </div>
        </ThemeProvider>
     </main>
    </>
  );
};
export default Account;
